var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttio = function SvgAttio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#attio_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.125 14.658 18.74 12.46l-.008-.013-.11-.173a1.12 1.12 0 0 0-.953-.525l-2.232-.007-.157.247-2.668 4.23-.147.234 1.118 1.769a1.12 1.12 0 0 0 .956.525h3.13c.385 0 .75-.201.955-.524l.11-.175.005-.007 1.389-2.2a1.11 1.11 0 0 0 0-1.183zm-.423.92-1.388 2.2-.02.027a.19.19 0 0 1-.238.034.2.2 0 0 1-.061-.062l-1.39-2.2a.63.63 0 0 1-.001-.655l1.387-2.198.003-.005a.17.17 0 0 1 .11-.079l.038-.007h.015c.032 0 .112.01.161.09l1.386 2.197a.62.62 0 0 1 0 .658zm-3.68-6.237a1.11 1.11 0 0 0 0-1.183L14.638 5.96l-.116-.185a1.12 1.12 0 0 0-.956-.523h-3.129c-.39 0-.748.196-.957.525l-5.603 8.882a1.1 1.1 0 0 0-.002 1.182l1.503 2.383a1.12 1.12 0 0 0 .955.524h3.13c.393 0 .75-.196.956-.525l.114-.18v-.002l.002-.004 1.118-1.77 3.31-5.247 1.059-1.678zm-.326-.592a.6.6 0 0 1-.097.33l-5.49 8.7a.19.19 0 0 1-.16.088.19.19 0 0 1-.161-.087L8.4 15.578a.62.62 0 0 1 0-.656l5.49-8.7a.19.19 0 0 1 .161-.089.19.19 0 0 1 .162.09L15.6 8.42a.6.6 0 0 1 .097.33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "attio_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 6
  })))));
};
export default SvgAttio;